<template>
  <v-card flat>
    <v-card-title class="title pb-0">
      {{ income.relationship }}
      <v-spacer />
      <v-btn small icon flat :color="themes.candidate.light.dangerButton" @click="$emit('destroy')">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
      <v-btn
        :color="themes.candidate.light.primaryActionButton"
        @click="$emit('edit')"
        class="ml-3"
        small
        fab
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <table class="v-table theme--light">
        <tbody>
          <tr>
            <th class="text-xs-left subheading" :class="themes.candidate.light.mutedText">Name</th>
            <td class="text-xs-left text-no-wrap" style="width: 100px;">
              {{ income.givenName }} {{ income.familyName }}
            </td>
          </tr>
          <tr>
            <th class="text-xs-left subheading" :class="themes.candidate.light.mutedText">
              Occupation
            </th>
            <td class="text-xs-left text-no-wrap" style="width: 150px;">{{ income.occupation }}</td>
          </tr>
          <tr>
            <th class="text-xs-left subheading" :class="themes.candidate.light.mutedText">
              Gross Income
            </th>
            <td class="text-xs-left text-no-wrap" style="width: 150px;">
              {{ currencyDisplay }} {{ income.grossIncome }} p/m
            </td>
          </tr>
          <tr>
            <th class="text-xs-left subheading" :class="themes.candidate.light.mutedText">
              Documentation
            </th>
            <td class="text-xs-left text-no-wrap" style="width: 150px;">
              <DocumentUploadButton
                :label="income.typeOfProof"
                :file="income.proof"
                :post="`/candidate/financial_survey/household_incomes/${income.id}/proof`"
                refresh="candidate/applications/fetch"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </v-card-text>
  </v-card>
</template>

<script>
// Components
import DocumentUploadButton from '@/components/candidate/DocumentUploadButton'

// Vue Component
export default {
  components: { DocumentUploadButton },
  props: {
    income: {
      type: Object,
      required: true,
    },
    currencyDisplay: String,
  },
}
</script>
